<script lang="ts" setup>
  import { useId } from 'vue';

  defineProps<{ gameCode: number }>();

  const labelId = useId();
  const valueId = useId();
</script>

<template>
  <div class="card-game-code">
    <div :id="labelId" class="card-game-code-label">game code</div>
    <h2 :id="valueId" :aria-labelledby="`${labelId} ${valueId}`" class="card-game-code-value">{{ gameCode }}</h2>
  </div>
</template>

<style scoped>
  .card-game-code {
    color: var(--color-on-primary);
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    line-height: 1;
    text-align: center;
  }

  .card-game-code-label {
    font-size: var(--font-size-xs);
    letter-spacing: 0.05rem;
    text-transform: uppercase;
  }

  .card-game-code-value {
    font-family: var(--font-code);
    font-size: var(--font-size-lg);
    font-weight: var(--font-weight-strong);
    margin: 0;
  }
</style>
